import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { SecurityService } from 'app/services/security/security.service';
import { ListadoSistemaComponent } from './listado-sistema/listado-sistema.component';

@Component({
  selector: 'app-sistema',
  templateUrl: './sistema.component.html',
  styleUrls: ['./sistema.component.scss'],
  providers:[MessagesTitles, MessagesStatus,ListadoSistemaComponent],
})
export class SistemaComponent {
  abrirPopUpSistema: boolean = false;
  constructor(private loginService:LoginService,
    private securityService: SecurityService,
    private router: Router ) {
      
    };
  clickGuard(){
    this.loginService.clickGuard = true;
}

AgregarSistema() {
  this.securityService.dataSistema = '';
  this.abrirPopUpSistema = true;
}
CerrarPopUpSistema() {
  this.abrirPopUpSistema = false;
  this.router.navigate(["/sistema/listado"]);
}
Refresh() {
  this.router.navigate(["/sistema/listado"]);
}
}
